import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppConstants } from 'src/app/constants/app.constants';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.css']
})
export class AgreementComponent implements OnInit {
  companyName = AppConstants.COMPANY_NAME;
  
  constructor(public dialogRef: MatDialogRef<AgreementComponent>) { }

  ngOnInit() {
  }

}
